import actions from './actions'
import getters from './getters'
import mutations from './mutations'

const state = {
  user: null,
  currentJWT: '',
  authIsReady: false,
  activeNursery: null,
  activeNurseryBranch: null,
  role: null,
  openingTimes: null,
  childNumber: null,
  jumpStepBack: false,
  userHasCompletedMigration: false,
  checkNotifications: false,
  updateChildren: false,
  userHasEnabledMarketplace: false,
  upgraded: false,
  userHasSuspendedNursery: false,
  userHasUpdatedChildren: false,
  currentKeyworkerChild: null,
  currentKeyworkerChildId: false,
  currentKeyworkerChildIndex: 0,
  redirectFromSignup: null,
  // User IDs who have clicked "None of these are mine" on the confirm-children
  // wizard — prevents the router guard from re-prompting them. Keyed by user id
  // so a shared-device logout/login doesn't leak one user's dismissal to another.
  // Persisted to localStorage; cross-device dismissal is not propagated.
  dismissedConfirmChildrenPromptUserIds: [],
  // User IDs who have submitted the complete-profile step. The profile form
  // only enforces names, so an empty contact section can't distinguish
  // "skipped the step" from "completed it minimally", but this marker can.
  // Same per-user/persistence semantics as the dismissal list above.
  completedProfileStepUserIds: [],
}

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations,
}
